import i18next from "i18next";
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Redirect } from 'react-router-dom';
import Api from "../../../lib/Api";
import bikeTypeSupportsFitting from "../FittingSupport";
import Progress from "../Progress";
import DynamicText from './DynamicText';
import DynamicTextRace from "./DynamicTextRace";
import PriceSlider from './PriceSlider';
import Loader from "../../Loader";

class Price extends Component {
	constructor(props) {
		super(props);
		this.state = {
			data: '',
			price: '',
			slider: 80,
			redirect: false,
			goBack: false
		};

		this.getAdvicePrice = this.getAdvicePrice.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleSlider = this.handleSlider.bind(this);
		this.goBack = this.goBack.bind(this);
	}

	componentWillReceiveProps(nextProps, nextContext) {
		this.getAdvicePrice(nextProps);
	}

	componentDidMount() {
		// scroll back to top page
		window.scrollTo(0, 0);
		// Get data from database and store in state
		i18next.on('languageChanged', () => { this.getAdvicePrice(this.props) });
		console.log(this.props.chosenIntegrationOption)
		this.getAdvicePrice(this.props);
	}

	render() {

		if (this.state.redirect) {
			return <Redirect to='/advice/result' />;
		}
		if (this.state.goBack) {
			return <Redirect to='/advice/sizes' />;
		}

		if (typeof (this.state.data) !== "undefined") {
			return (
				<div className="container main">
					<link href="/css/simple-slider.css" rel="stylesheet" type="text/css" />
					<Progress goTo={this.props.goTo} step={3} traject={this.props.traject} />
					<div className="d-flex justify-content-center align-items-center ">
						<h2>{this.props.t('Price_Advice_Title')}</h2>
					</div>
					<div className="d-flex justify-content-center align-items-center ">
						<h4>{this.props.t('Price_Advice_Subtitle')}</h4>
					</div>
					<form className="row price" onSubmit={this.handleSubmit}>

						<PriceSlider
							advicePrice={this.state.advicePrice}
							steps='100'
							min='100'
							max={this.props.priceMax}
							handle={this.handleSlider}
						/>

						{this.props.traject === 'mtb' &&
							<DynamicText
								title={this.props.t('Waarom dit advies?')}
								experience={this.props.experience}
								bikeType={this.props.mtbType}
								suspension={this.props.suspension}
								mtbType={this.props.mtbType}
								speed={this.props.speed}
								advicePrice={this.state.advicePrice}
							/>
						}

						{this.props.traject === 'race' &&
							<DynamicTextRace
								title={this.props.t('Waarom dit advies?')}
								experience={this.props.experience}
								bikeType={this.props.mtbType}
								image={this.props.image}
								mtbType={this.props.mtbType}
								speed={this.props.speed}
								advicePrice={this.state.advicePrice}
							/>
						}

						<div className="col-6 text-left">
							<button className="back btn btn-link" onClick={this.goBack}>
								<i className="fas fa-caret-left"></i> {this.props.t('Terug naar vorige stap')}</button>
						</div>
						<div className="col-6 text-right">
							<input id="submitbtn" className={'btn btn-secondary gtm-' + this.props.traject + '-bikefinder-results'} type="submit" value={this.props.t('Krijg advies')} />
						</div>
					</form>
				</div>
			);
		} else {
			return <Loader />;
		}
	}
	getAdvicePrice(props) {
		let url = '/advice-price';
		let get = {
			experience: props.experience,
			speed: props.speed,
			suspension: props.suspension,
			usage: props.usage,
			bike_type: props.mtbType,
			bike_cat: props.traject,
			image: props.image
		};
		Api.get(url, get).then(response => {
			this.setState({ data: response.data });
			this.setState({ value: response.data.data });
			this.setState({ advicePrice: response.data.data });
			this.setState({ price: response.data.data });
		})
	}
	handleSlider(value) {
		this.setState({ price: value });
	}
	handleSubmit(event) {
		event.preventDefault();
		this.props.handler(this.state.price)
			.then(() => this.props.goTo('/advice/beforeresults', this.props.traject));
	}
	goBack(e) {
		e.preventDefault();

		if (this.props.chosenIntegrationOption === "option1" || this.props.chosenIntegrationOption === "option2") {
			this.props.goTo('/advice/integration', this.props.traject);
		} else if (bikeTypeSupportsFitting(this.props.mtbType)) {
			this.props.goTo('/advice/sizes', this.props.traject);
		} else {
			this.props.goTo('/advice/gender', this.props.traject);
		}
	}
}

export default withTranslation('price')(Price);
